import { useGetIdentity, useTranslate, useLogout, useNavigation } from '@pankod/refine-core';
import { EditOutlined, InfoCircleOutlined, LogoutOutlined } from '@ant-design/icons';
import { Card, Menu } from 'antd';
import { useCallback } from 'react';
import type { MenuProps } from 'antd';
import { User } from 'interfaces';

type MenuItem = Required<MenuProps>['items'][number];

function getItem(
  label: React.ReactNode,
  key?: React.Key | null,
  icon?: React.ReactNode,
): MenuItem {
  return { key, icon, label } as MenuItem;
}

export const ProfileMenu: React.FC = () => {
  const t = useTranslate();
  const { push } = useNavigation();
  const { mutate: logout } = useLogout();
  const { data: user } = useGetIdentity<User>();

  const getUserName = useCallback((userData: User) => {
    let name = userData.firstname ?? 'John';
    let lastname = userData.lastname ?? 'Doe';
    name = name.charAt(0).toUpperCase() + name.slice(1);
    lastname = lastname.charAt(0).toUpperCase() + lastname.slice(1);
    return `${name} ${lastname}`;
  }, []);

  const items: MenuItem[] = [
    getItem("Mon Profil", 'my-info'),
    getItem("FAQ", 'faq'),
    getItem("Se Déconnecter", 'logout'),
  ];

  const onMenuClick: MenuProps['onClick'] = (e: any) => {
    switch (e.key) {
      case 'my-info':
        push('/user/profile');
        break;
      case 'faq':
        push('/faq');
        break;
      case 'logout':
        logout();
        break;
    }
    return;
  };

  return (
    <Card className="w-[250px] rounded-xl border border-gray-200 bg-white p-3 shadow-md">
      <div className="mb-3">
        <h2 className="text-base font-semibold text-gray-800">
          {user ? getUserName(user) : 'Invité'}
        </h2>
        <p className="text-xs text-gray-500">{user?.email ?? 'guest@example.com'}</p>
      </div>
      <Menu
        onClick={onMenuClick}
        className="border-none font-medium"
        mode="vertical"
        items={items}
        style={{ border: 'none' }}
      />
    </Card>
  );
};
